/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

'use client';

import { Suspense } from 'react';

import { PageLoader } from '@/components/common/SuspenseLoader';
import { useTranslation } from '@/lib/i18n';
import { useEnhancedTheme } from '@/providers';

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

/**
 * Cray Theme - Categories Page Override
 *
 * This is an example of how themes can override default route implementations.
 * This component will be used instead of the default categories page.
 */

export default function CrayCategoriesPage() {
  return (
    <Suspense fallback={<PageLoader message="Loading categories..." />}>
      <CrayCategoriesContent />
    </Suspense>
  );
}

function CrayCategoriesContent() {
  const { design } = useEnhancedTheme();
  const { t } = useTranslation();

  // Cray theme specific implementation
  const categories = [
    { id: 1, name: 'Electronics', slug: 'electronics', count: 245 },
    { id: 2, name: 'Clothing', slug: 'clothing', count: 532 },
    { id: 3, name: 'Home & Garden', slug: 'home-garden', count: 187 },
    { id: 4, name: 'Sports', slug: 'sports', count: 321 },
  ];

  return (
    <div
      style={{
        padding: design?.spacing.xl,
        maxWidth: '1200px',
        margin: '0 auto',
      }}
    >
      <div style={{ marginBottom: design?.spacing.xl }}>
        <h1
          style={{
            fontSize: '2.5rem',
            marginBottom: design?.spacing.md,
            color: design?.colors.text,
          }}
        >
          {t('categories.title')}
        </h1>
        <p
          style={{
            fontSize: '1.1rem',
            color: design?.colors.textSecondary,
          }}
        >
          {t('app.description')}
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: design?.spacing.lg,
        }}
      >
        {categories.map((category) => (
          <a
            key={category.id}
            href={`/categories/${category.slug}`}
            style={{
              padding: design?.spacing.xl,
              backgroundColor: design?.colors.surface,
              borderRadius: design?.borderRadius.lg,
              border: `1px solid ${design?.colors.border}`,
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = design?.colors.primary || '';
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = design?.colors.border || '';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <h3
              style={{
                fontSize: '1.5rem',
                marginBottom: design?.spacing.sm,
                color: design?.colors.text,
              }}
            >
              {category.name}
            </h3>
            <p
              style={{
                color: design?.colors.textSecondary,
                fontSize: '0.9rem',
              }}
            >
              {category.count} {t('categories.productsCount')}
            </p>
          </a>
        ))}
      </div>

      <div
        style={{
          marginTop: design?.spacing.xl,
          padding: design?.spacing.lg,
          backgroundColor: design?.colors.surfaceHover,
          borderRadius: design?.borderRadius.md,
          textAlign: 'center',
        }}
      >
        <p
          style={{
            color: design?.colors.textSecondary,
            fontSize: '0.9rem',
          }}
        >
          🎨 This page is rendered by the <strong>Cray theme</strong> override
        </p>
      </div>
    </div>
  );
}
